import classNames from "classnames";
import SVGOpen from "../../icons/Open.svg?react";
import { Newsletter } from "../../types/types";
import styles from "../ListItem.module.css";
import Icon from "../ui/Icon";
import Link from "../ui/Link";

interface Props {
  item: Newsletter;
}

const NewsletterItem = ({ item }: Props) => (
  <tr className={classNames(styles.row, styles["row-grid-wide"])}>
    <td className={styles.label}>{item.title}</td>
    <td>{formatDate(new Date(item.date))}</td>
    <td>
      <Link newTab={true} url={item.link} className={styles["btn-download"]}>
        <Icon className={styles["btn-icon"]} glyph={SVGOpen} />
        <span className={styles["btn-label"]}>Lesen</span>
      </Link>
    </td>
  </tr>
);

export default NewsletterItem;

const padTo2Digits = (num: number) => num.toString().padStart(2, "0");

const formatDate = (date: Date) =>
  [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join(".");
